import React, { useState } from 'react';
import { Button, message } from 'antd';
import { BellOutlined, CheckCircleOutlined, CloseOutlined } from '@ant-design/icons';
import usePushNotifications from '../../hooks/usePushNotifications';

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';

const LS_DISMISSED = 'push_onboarding_dismissed_v1';

// Card destacado no dashboard convidando o jogador a ativar push.
// Some quando: (a) ja tá inscrito, (b) navegador nega permissao, (c) user dispensa.
export default function PushOnboardingCard() {
  const { status, subscribed, loading, subscribe } = usePushNotifications({ basePath: '/push/player' });
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(LS_DISMISSED) === '1');
  const [busy, setBusy] = useState(false);

  if (subscribed) return null;
  if (status === 'denied') return null;
  if (status === 'unsupported') return null;
  if (dismissed) return null;

  const handleSubscribe = async () => {
    setBusy(true);
    try {
      const r = await subscribe();
      if (r?.ok) message.success('Notificações ativadas!');
      else if (r?.reason === 'permission_denied') message.warning('Você negou a permissão. Reative nas configurações do navegador.');
      else message.error('Não deu pra ativar agora — tenta de novo');
    } catch { message.error('Erro ao ativar'); }
    finally { setBusy(false); }
  };

  const dismiss = () => {
    localStorage.setItem(LS_DISMISSED, '1');
    setDismissed(true);
  };

  return (
    <div style={{
      background: `linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)`,
      border: '1px solid #fbbf24',
      borderRadius: 16, padding: 16, marginBottom: 16,
      position: 'relative', overflow: 'hidden',
      boxShadow: '0 8px 24px rgba(251, 191, 36, 0.2)',
    }}>
      <button onClick={dismiss}
        style={{
          position: 'absolute', top: 8, right: 8, background: 'transparent', border: 'none',
          cursor: 'pointer', color: '#92400e', fontSize: 14, opacity: 0.7,
        }}>
        <CloseOutlined />
      </button>

      <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
        <div style={{
          width: 48, height: 48, borderRadius: 12,
          background: '#fff', color: '#f59e0b',
          display: 'grid', placeItems: 'center', fontSize: 24,
          flexShrink: 0, boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        }}>
          <BellOutlined />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 900, color: '#78350f', lineHeight: 1.2 }}>
            Ative as notificações
          </div>
          <div style={{ fontSize: 12, color: '#92400e', marginTop: 4, lineHeight: 1.4, opacity: 0.9 }}>
            Recebe convite direto no celular. Sabe na hora quando alguém te chama pra jogar.
          </div>
        </div>
        <Button
          type="primary"
          size="middle"
          icon={loading || busy ? null : <CheckCircleOutlined />}
          loading={loading || busy}
          onClick={handleSubscribe}
          style={{
            background: BRAND_DARK, borderColor: BRAND_DARK, fontWeight: 700,
            height: 40, borderRadius: 10, flexShrink: 0,
            boxShadow: '0 4px 12px rgba(18, 140, 126, 0.35)',
          }}
        >
          Ativar
        </Button>
      </div>
    </div>
  );
}
